export enum RADIO_OPTION_TYPE {
    YES = 'RADIOBTN.VALUE1',
    NO = 'RADIOBTN.VALUE2',
    NA = 'RADIOBTN.VALUE3',
}

export enum RADIO_OPTION_SELECTED {
    YES = 'YES',
    NO = 'NO',
}

export type RadioOption = Readonly<{
    xmlId: string;
    optionType: RADIO_OPTION_TYPE;
    selected: boolean;
    // this is relevant to show or hide checkpoints in participant copies (MARS-276)
    selectedInMaster: boolean;
    contentLoadedFromXml: boolean; // was the content of this checkpoint loaded from an interim XML document
    disabled: boolean;
}>;

export const initialRadioOptionState: RadioOption = {
    xmlId: '',
    optionType: RADIO_OPTION_TYPE.NA,
    selected: false,
    selectedInMaster: false,
    contentLoadedFromXml: false,
    disabled: false,
};
